<script setup lang="ts">
import { computed } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { t } from '@/locales/i18n'
import GwText from '@/components/lib/base/GwText/GwText.vue'
import GwBox from '@/components/lib/GwBox/GwBox.vue'
import * as R from 'remeda'
import { refDebounced } from '@vueuse/core'
import { scoreBreakdownQueryKey, getScoreBreakdown } from '../../../../store/api/gql/hands/queries'
import type { Filter } from '../../../../types/api/reports'
import { generateFilterParams } from '../../../../store/api/gql/hands/utils'
import GTOScoreChart from './ScoreBreakdown/GTOScoreChart.vue'

const props = defineProps<{
  filters: Filter[]
  gtoScore?: number
}>()

const filterParams = computed(() => generateFilterParams(props.filters))
const queryKey = computed(() => [...scoreBreakdownQueryKey, filterParams.value])

const { data } = useQuery({
  queryKey: refDebounced(queryKey, 300),
  queryFn: getScoreBreakdown(filterParams),
  refetchOnWindowFocus: false,
  placeholderData: R.identity,
})
</script>
<template>
  <GwBox
    variant="box_gradient180"
    style="padding: var(--app-pad-6)"
  >
    <div
      class="f-column"
      style="gap: var(--app-gap-4)"
    >
      <GwText variant="text_grey_normal-large_500">
        {{ t('hhv3.score_breakdown_count_moves') }}
      </GwText>
      <GTOScoreChart :scoreBreakdown="data?.score_breakdown"> </GTOScoreChart>
    </div>
  </GwBox>
</template>
